//chapter1
export default {
    id : 13,//chapter number
    title : '13. DFMEA 작성방법 (6) - DFMEA 최적화',//chapter name
    slides : [
        {
            title : 'Intro',
            type : 'intro',
            source : 'c13.mp4',
        },
        {
            title : 'Today’s Goal',
            type : 'plan',
            body1 : [
                'DFMEA 최적화',
            ],
            body2 : [
                'DFMEA 최적화에 대해 설명할 수 있다.'
            ],
            bgm : "plan.mp3"
        },
        {
            title : 'Lesson',
            type : 'lesson',
            source : '13.mp4',
        },
        {
            title : 'Quiz',
            type : 'quiz',
            quiz : [
                {
                    type : 'ox',
                    question : '최적화는 위험감소를 위한 조치의 정의와 결과의 f/up이다.',//html available
                    answer : "1",
                    explain : '최적화는 위험감소를 위한 전체적인 조치이다.'
                },
                {
                    type : 'ox',
                    question : 'FMEA는 개발과정에서 작성된 문서로서 역할을 완료한다.',//html available
                    answer : "2",
                    explain : 'FMEA는 살아있는 문서로서 계속해서 관리되어야 한다.'
                },
            ],
            quizMask : "../assets/images/quiz_intro.jpg",//quiz mask
            bgm : "quiz.mp3"
        },
        {
            title : 'Summary',
            type : 'summary',
            /*download : 'sample.pptx',//data folder*/
            print : false,// true : show, false: hide
            slides : [
                {
                    body : `<ul>
                        <h3>1. 최적화 개요</h3>
                        <li>최적화 목적 : 효과성 평가, 지속적 개선</li>
                        <p class="mg10"></p>
                        <h3>2. 개선조치 F/UP 방안</h3>
                        <p class="mg10"></p>
                        <h3>3. DFMEA 작성연습</h3>
                        <li>사례(라이터)를 이용한 작성연습</li>
                        <li>Block Boundary 작성</li>
                        <p class="mg10"></p>
                        <h3>4. 양식 사용방법</h3>
                    </ul>`
                },
            ],
            bgm : "summary.mp3"
        },
        {
            title : 'Outro',
            type : 'outro',
            source : 'c13.mp4',
        },
    ]
}